import React from 'react';
import classNames from 'classnames';
import { DevNavigationBar } from './components/DevNavigationBar';
import { appStage } from 'helpers';
import { Redirect } from 'react-router-dom';
import styles from './DevelopmentMenu.module.scss';
import { FlagRow } from './components/FlagRow';
import { allFlags } from './utils';
import { ButtonRow } from './components/ButtonRow';
import { handleFlagChange } from 'services/featureFlags';

export const DevelopmentMenu = () => {
  if (appStage === 'prod') {
    return <Redirect to={'/'} />;
  }

  return (
    <>
      <DevNavigationBar />
      <div className={styles.content}>
        <div className={classNames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <div className={styles.Heading1}>Development Menu</div>
            {allFlags.map((section: any, key: number) => (
              <div key={key} className={styles.SectionBody}>
                <div className={styles.Heading2}>{section.section}</div>
                {section.flags.map((flag: any, key: number) => (
                  <FlagRow
                    key={key}
                    flagName={flag.name}
                    flagDesc={flag.description}
                    flagKey={flag.key}
                  />
                ))}
              </div>
            ))}
            <div className={styles.SectionBody}>
              <div className={styles.Heading2}>Actions</div>
              <ButtonRow
                name={'Chrome Extension: New Feature Flag Detected'}
                desc={'Purge and reload other open extensions'}
                onClick={() => handleFlagChange()}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
